"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearMerchantPortalAccountLookup = void 0;
const redux_actions_1 = require("redux-actions");
exports.clearMerchantPortalAccountLookup = (0, redux_actions_1.createAction)('CLEAR_MERCHANT_PORTAL_ACCOUNT_LOOKUP');
